import { z } from "zod";
export const CRM_CONTACT_NOTICE_VERSION = "DEMO_CONTACT_V1";
export const crmLeadStatusSchema = z.enum([
    "NEW",
    "CONTACTED",
    "QUALIFIED",
    "DEMO_SCHEDULED",
    "DEMO_COMPLETED",
    "PILOT",
    "WON",
    "LOST",
]);
export const demoRequestSchema = z
    .object({
    submissionId: z.string().uuid(),
    name: z.string().trim().min(2).max(120),
    email: z.string().trim().toLowerCase().email().max(254),
    company: z.string().trim().min(2).max(160),
    message: z.string().trim().min(10).max(2000),
    locale: z.enum(["pt-BR", "es", "en"]),
    contactConsent: z.literal(true),
    contactNoticeVersion: z.literal(CRM_CONTACT_NOTICE_VERSION),
    website: z.string().max(0).optional(),
})
    .strict();
export const demoReceiptSchema = z.object({
    id: z.string().uuid(),
    status: z.literal("RECEIVED"),
    receivedAt: z.string().datetime(),
});
export const crmLeadSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    company: z.string(),
    message: z.string(),
    locale: z.enum(["pt-BR", "es", "en"]),
    status: crmLeadStatusSchema,
    source: z.literal("LANDING_DEMO"),
    receivedAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    owner: z.object({ id: z.string().uuid(), label: z.string() }).nullable(),
    nextContactAt: z.string().datetime().nullable(),
    demoAt: z.string().datetime().nullable().default(null),
    revision: z.number().int().positive(),
    contactNoticeVersion: z.literal(CRM_CONTACT_NOTICE_VERSION),
});
export const crmLeadQuerySchema = z
    .object({
    q: z.string().trim().max(160).optional(),
    status: crmLeadStatusSchema.optional(),
    owner: z.enum(["mine", "unassigned"]).optional(),
    followUp: z.literal("overdue").optional(),
    cursor: z.string().max(256).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
})
    .strict();
export const crmLeadPageSchema = z.object({
    items: z.array(crmLeadSchema),
    nextCursor: z.string().nullable(),
});
export const crmActivitySchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    actor: z.string().nullable(),
    kind: z.enum(["RECEIVED", "UPDATED", "NOTE"]),
    note: z.string().nullable(),
    changes: z.object({
        status: crmLeadStatusSchema.optional(),
        ownerChanged: z.boolean().optional(),
        ownerId: z.string().uuid().nullable().optional(),
        demoChanged: z.boolean().optional(),
        demoAt: z.string().datetime().nullable().optional(),
        nextContactChanged: z.boolean().optional(),
        nextContactAt: z.string().datetime().nullable().optional(),
    }),
});
export const crmLeadDetailSchema = z.object({
    lead: crmLeadSchema,
    activity: z.array(crmActivitySchema),
});
export const crmLeadUpdateSchema = z
    .object({
    revision: z.number().int().positive(),
    status: crmLeadStatusSchema.optional(),
    assignToMe: z.boolean().optional(),
    nextContactAt: z.string().datetime({ offset: true }).nullable().optional(),
    demoAt: z.string().datetime({ offset: true }).nullable().optional(),
    note: z.string().trim().min(1).max(2000).optional(),
})
    .strict()
    .refine((value) => value.status !== undefined ||
    value.assignToMe !== undefined ||
    value.demoAt !== undefined ||
    value.nextContactAt !== undefined ||
    value.note !== undefined, { message: "At least one change is required" });
//# sourceMappingURL=crm.js.map